"use client"
import "./Card.css"
import logo from '../../assets/images/matcha-logo.svg'; // Update the path to your logo image
import { useGame } from '../../contexts/GameContext';
import { useAudio } from '../../contexts/AudioContext';

function Card({ value, isFlipped, onClick, status }) {
  const { playSound } = useAudio()

  // Determine the class based on status and isFlipped
  const cardClass = `card ${isFlipped ? "flipped" : ""} ${status || ""}`

  const handleClick = () => {
    if (!isFlipped) {
      playSound('flip')
      onClick()
    }
  }

  return (
    <div className={cardClass} onClick={handleClick}>
      <div className="card-inner">
        <div className="card-front">
          <img src={logo || "/placeholder.svg"} alt="Logo" className="card-logo" />
        </div>
        <div className="card-back">{value}</div>
      </div>
    </div>
  )
}

export default Card

